module.exports = __webpack_public_path__ + "images/pages/vocal-fold/complaints-2.svg";